import * as React from 'react';
import { SVGProps } from 'react';

export const ExcusedSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path opacity={0.4} d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="#9CA3AF" />
        <path
            d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM4 16 16 4"
            stroke="#9CA3AF"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ExtraCreditSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="m11.028 1.664 1.87 3.996a1.13 1.13 0 0 0 .86.649l4.27.649a1.15 1.15 0 0 1 .942 1.383 1.149 1.149 0 0 1-.292.545l-3.17 3.256a1.137 1.137 0 0 0-.31.998l.74 4.535a1.127 1.127 0 0 1-1.056 1.324c-.214.01-.427-.04-.614-.146l-3.72-2.057a1.13 1.13 0 0 0-1.1 0l-3.72 2.057a1.131 1.131 0 0 1-1.67-1.178l.74-4.535a1.138 1.138 0 0 0-.31-.998l-3.17-3.256a1.148 1.148 0 0 1 .65-1.928l4.27-.65a1.13 1.13 0 0 0 .86-.648l1.87-3.996a1.13 1.13 0 0 1 2.06 0Z"
            fill="#FEF5E1"
            stroke="#FFAB00"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.528 9.495s2.34 3.376 5 0"
            stroke="#FFAB00"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IncompleteSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path opacity={0.4} d="M9.8 18.8a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="#6848D4" />
        <path
            d="M9.8 18.8a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM5.8 9.8h8"
            stroke="#6848D4"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const LateSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            opacity={0.4}
            d="M12 9.6c1.334-.919 3.4-2.1 3.4-3.5v-.7H4.5V6c0 1.4 2.1 3.5 3.4 3.5h.839v2.884c-2.2.8-3.84 3.616-3.84 6.016H14.9c0-2.4-1.445-5.216-3.645-6.016V9.6H12Z"
            fill="#FF5722"
        />
        <path
            d="M16 4V2H4v2c0 2.8 1.6 4.2 4 5.3v1.4c-1.4 1.1-4 2.5-4 5.3v2h12v-2c0-2.8-1.6-4.2-4-5.3V9.3c2.3-1.2 4-2.6 4-5.3Z"
            stroke="#FF5722"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const MissedSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16.222 17H3.778C2.8 17 2 16.1 2 15V9c0-1.1.8-2 1.778-2h12.444C17.2 7 18 7.9 18 9v6c0 1.1-.8 2-1.778 2Z"
            fill="#FFCED1"
            stroke="#FF333F"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 7V5a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v2M10 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            stroke="#FF333F"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ReassignSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16 18.5H4.5c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2H12l.5 6H18v9c0 1.1-.9 2-2 2Z"
            fill="#FFCEE0"
        />
        <path
            d="M12 1.5v4c0 1.1.9 2 2 2h4"
            stroke="#FF337C"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18 7.5v9.05c0 1.1-.9 2-2 2L4.5 18.5c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2H12l6 6Z"
            stroke="#FF337C"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 18.5v-7h6"
            stroke="#FF337C"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m11 9.5 2 2-2 2"
            stroke="#FF337C"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const SkipSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="m18.55 11.05-7.5 7.5c-.6.6-1.5.6-2.1 0l-7.5-7.5c-.6-.6-.6-1.5 0-2.1l7.5-7.5c.6-.6 1.5-.6 2.1 0l7.5 7.5c.6.6.6 1.5 0 2.1Z"
            stroke="#2278ED"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            opacity={0.4}
            d="m18.55 11.05-7.5 7.5c-.6.6-1.5.6-2.1 0l-7.5-7.5c-.6-.6-.6-1.5 0-2.1l7.5-7.5c.6-.6 1.5-.6 2.1 0l7.5 7.5c.6.6.6 1.5 0 2.1Z"
            fill="#2278ED"
        />
        <path
            d="m12.05 8.05 2 2-2 2M7.05 8.05l2 2-2 2"
            stroke="#2278ED"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ActivityDoneSVG = ({
    stroke = '#3B516A',
    fill = '#3B516A',
    strokeWidth = 1.5,
    ...props
}: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M11.602 1.9c-.953-.7-2.25-.7-3.204 0l-1.031.757c-.206.151-.445.25-.697.289l-1.265.194A2.707 2.707 0 0 0 3.14 5.405L2.946 6.67a1.582 1.582 0 0 1-.289.697L1.9 8.398c-.7.953-.7 2.25 0 3.204l.757 1.031c.151.206.25.445.289.697l.194 1.265a2.707 2.707 0 0 0 2.265 2.265l1.265.194c.252.039.491.138.697.289l1.031.757c.953.7 2.25.7 3.204 0l1.031-.757c.206-.151.445-.25.697-.289l1.265-.194a2.707 2.707 0 0 0 2.265-2.265l.194-1.265c.039-.252.138-.491.289-.697l.757-1.031c.7-.953.7-2.25 0-3.204l-.757-1.031a1.584 1.584 0 0 1-.289-.697l-.194-1.265a2.707 2.707 0 0 0-2.265-2.265l-1.265-.194a1.582 1.582 0 0 1-.697-.289L11.602 1.9Z"
            stroke={stroke}
            strokeWidth={strokeWidth}
        />
        <path
            d="M7.53 9.47a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM9 12l-.53.53a.75.75 0 0 0 1.06 0L9 12Zm5.03-3.97a.75.75 0 0 0-1.06-1.06l1.06 1.06Zm-7.56 2.5 2 2 1.06-1.06-2-2-1.06 1.06Zm3.06 2 4.5-4.5-1.06-1.06-4.5 4.5 1.06 1.06Z"
            fill={fill}
        />
    </svg>
);

export const ActivityLateIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            opacity={0.4}
            d="M12 9.6c1.334-.919 3.4-2.1 3.4-3.5v-.7H4.5V6c0 1.4 2.1 3.5 3.4 3.5h.839v2.884c-2.2.8-3.84 3.616-3.84 6.016H14.9c0-2.4-1.445-5.216-3.645-6.016V9.6H12Z"
            fill="#FF5722"
        />
        <path
            d="M16 4V2H4v2c0 2.8 1.6 4.2 4 5.3v1.4c-1.4 1.1-4 2.5-4 5.3v2h12v-2c0-2.8-1.6-4.2-4-5.3V9.3c2.3-1.2 4-2.6 4-5.3Z"
            stroke="#FF5722"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
